import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { UserProvider } from './context/UserContext';
import reportWebVitals from './reportWebVitals';

// Mobile debugging: display uncaught JS errors on screen
window.addEventListener('error', (e) => {
  const el = document.getElementById('__crash');
  if (el) el.textContent = `[JS Error] ${e.message} (${e.filename}:${e.lineno})`;
});
window.addEventListener('unhandledrejection', (e) => {
  const el = document.getElementById('__crash');
  if (el) el.textContent = `[Promise] ${e.reason}`;
});

class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: 'monospace', fontSize: 13, color: '#900', background: '#fff' }}>
          <h2>An error occurred while loading the app</h2>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {this.state.error.message}{'\n'}{this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <UserProvider>
        <App />
      </UserProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();

// Unregister CRA default service workers (keep push notification sw.js)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      if (!r.active?.scriptURL?.includes("/sw.js")) r.unregister();
    });
  });
}
